function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
export var SnackbarContext = /*#__PURE__*/ React.createContext(null);
var SnackbarMessage = function() {
    var _React_useContext = React.useContext(SnackbarContext), message = _React_useContext.message, isSnackbarOpen = _React_useContext.isSnackbarOpen, setSnackbarOpen = _React_useContext.setSnackbarOpen, severity = _React_useContext.severity;
    return /*#__PURE__*/ _jsx(SnackbarAlert, {
        message: message,
        isSnackbarOpen: isSnackbarOpen,
        setSnackbarOpen: setSnackbarOpen,
        severity: severity
    });
};
export var SnackbarAlert = function(param) {
    var message = param.message, severity = param.severity, setSnackbarOpen = param.setSnackbarOpen, isSnackbarOpen = param.isSnackbarOpen;
    return /*#__PURE__*/ _jsx(Snackbar, {
        anchorOrigin: {
            vertical: "top",
            horizontal: "center"
        },
        open: isSnackbarOpen,
        autoHideDuration: 3000,
        onClose: function() {
            return setSnackbarOpen(false);
        },
        children: /*#__PURE__*/ _jsx(MuiAlert, {
            elevation: 6,
            variant: "filled",
            severity: severity,
            onClose: function() {
                return setSnackbarOpen(false);
            },
            children: message
        })
    });
};
export function useSnackbar() {
    var _React_useState = _sliced_to_array(React.useState(false), 2), isSnackbarOpen = _React_useState[0], setSnackbarOpen = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), message = _React_useState1[0], setMessage = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState("error"), 2), severity = _React_useState2[0], setSeverity = _React_useState2[1];
    var showSnackbar = React.useCallback(function(message, severity) {
        setMessage(message);
        setSeverity(severity || "error");
        setSnackbarOpen(true);
    }, []);
    return [
        {
            isSnackbarOpen: isSnackbarOpen,
            message: message,
            severity: severity,
            showSnackbar: showSnackbar
        },
        setSnackbarOpen
    ];
}
export function useSnackbarContext() {
    return React.useContext(SnackbarContext);
}
export default SnackbarMessage;
